// Totalsumma (antal × styckpris) på produkter utan häckkalkylator.
//
// Startsumman renderas server-side i lw_single_product_total_price.php; här
// räknas den om live när kunden ändrar antal — tier-medvetet, samma logik som
// effectivePrice() i hedge-calculator.js.
//
// Variabla produkter byter dessutom underlag vid variantbyte: varje variant
// bär sitt eget lw_total_unit_price + lw_total_tiers i variations-JSON:en.
// Ingen vald variant (WC visar prisintervall) → raden döljs.
document.addEventListener('DOMContentLoaded', function () {
    const total = document.querySelector('[data-lw-product-total]')
    if (!total) return

    const qtyInput = total.closest('form.cart')?.querySelector('input[name="quantity"]')
    if (!qtyInput) return

    const valueEl = total.querySelector('[data-lw-product-total-value]')
    if (!valueEl) return

    function parseTiers(raw) {
        try {
            const parsed = JSON.parse(raw || '[]')
            return Array.isArray(parsed) ? parsed : []
        } catch (e) {
            // ignorera parse-fel — utan tiers används styckpriset rakt av
            return []
        }
    }

    let unitPrice = parseFloat(total.dataset.unitPrice) || 0
    let tiers = parseTiers(total.dataset.tiers)

    // Butikens prisformat, speglat från wc_price()-inställningarna i PHP så att
    // den omräknade summan ser exakt likadan ut som den server-renderade.
    const decimals = parseInt(total.dataset.decimals, 10)
    const format = {
        decimals: Number.isFinite(decimals) ? decimals : 2,
        decimalSep: total.dataset.decimalSep ?? ',',
        thousandSep: total.dataset.thousandSep ?? ' ',
        trimZeros: total.dataset.trimZeros === '1',
    }

    function formatAmount(amount) {
        const fixed = Math.abs(amount).toFixed(format.decimals)
        const [whole, fraction] = fixed.split('.')
        let out = whole.replace(/\B(?=(\d{3})+(?!\d))/g, format.thousandSep)

        if (format.decimals > 0 && !(format.trimZeros && /^0+$/.test(fraction))) {
            out += format.decimalSep + fraction
        }

        return (amount < 0 ? '-' : '') + out
    }

    function effectivePrice(qty) {
        for (const tier of tiers) {
            const max = tier.max && tier.max > 0 ? parseInt(tier.max, 10) : Infinity
            if (qty >= parseInt(tier.min, 10) && qty <= max) return parseFloat(tier.price)
        }
        return unitPrice
    }

    // Besparingen finns på två ställen i markupen: hela meningen efter priset på
    // desktop, kortformen bredvid minsta kvantitet på mobil. Vilken som syns
    // avgörs av CSS; här fylls och växlas båda. Varje text bär sin egen
    // översatta mall i data-template, så formuleringarna bara finns i PHP.
    const savingsEls = total.querySelectorAll('[data-lw-product-total-savings]')
    const savingsTexts = total.querySelectorAll('[data-lw-savings-text]')

    function update() {
        const qty = parseInt(qtyInput.value, 10)
        if (!Number.isFinite(qty) || qty < 1) return

        const unit = effectivePrice(qty)
        valueEl.textContent = formatAmount(unit * qty) + ' kr'

        if (!savingsEls.length) return
        const savings = (unitPrice - unit) * qty
        if (savings > 0) {
            const amount = formatAmount(savings) + ' kr'
            savingsTexts.forEach(function (el) {
                el.textContent = (el.dataset.template || '').replace('%s', amount)
            })
            savingsEls.forEach(function (el) {
                el.classList.remove('hidden')
            })
        } else {
            savingsEls.forEach(function (el) {
                el.classList.add('hidden')
            })
        }
    }

    qtyInput.addEventListener('input', update)
    qtyInput.addEventListener('change', update)

    // --- Variabla produkter: byt underlag vid variantbyte ---
    if (!window.jQuery) return

    window.jQuery(function ($) {
        const form = $('form.variations_form')
        if (!form.length) return

        form.on('found_variation', function (event, variation) {
            unitPrice = parseFloat(variation && variation.lw_total_unit_price) || 0
            tiers = Array.isArray(variation && variation.lw_total_tiers) ? variation.lw_total_tiers : []

            total.classList.toggle('hidden', unitPrice <= 0)
            if (unitPrice > 0) update()
        })

        form.on('reset_data hide_variation', function () {
            unitPrice = 0
            tiers = []
            total.classList.add('hidden')
        })
    })
})
